var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-picker",on:{"click":_vm.toggle}},[_c('img',{staticClass:"flag",attrs:{"src":_vm.getImgUrl(`lang/${_vm.currentLocale}.png`)}}),_c('span',[_vm._v(_vm._s(_vm.$t('code')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }